var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavigateTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 7,
    viewBox: "0 0 11 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.615152 1.82416C0.212654 1.40669 0.22479 0.74198 0.642258 0.339483C1.05972 -0.0630143 1.72444 -0.0508785 2.12693 0.366589L5.32447 3.68305L8.64092 0.485516C9.05839 0.083019 9.7231 0.0951547 10.1256 0.512622C10.5281 0.930089 10.516 1.5948 10.0985 1.9973L6.02615 5.92362C5.60868 6.32611 4.94397 6.31398 4.54147 5.89651L0.615152 1.82416Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigateTop);
export default __webpack_public_path__ + "static/media/navigate_top.839fd3bbf5a5128bae811cd175e436a2.svg";
export { ForwardRef as ReactComponent };